import { jsxs as o, Fragment as t, jsx as r } from "react/jsx-runtime";
const n = () => /* @__PURE__ */ o(t, { children: [
  /* @__PURE__ */ r("path", { d: "M12 4V15M12 15L16 11M12 15L8 11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M3 15C3 17.8003 3 17.2004 3.54497 18.27C4.02433 19.2108 4.78924 19.9757 5.73005 20.455C6.79961 21 8.19974 21 11 21H13C15.8003 21 17.2004 21 18.27 20.455C19.2108 19.9757 19.9757 19.2108 20.455 18.27C21 17.2004 21 17.8003 21 15",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] });
export {
  n as default
};
